import { z } from "@/shared/validation/zod";

const runtimeConfigSchema = z.object({
  VITE_API_BASE_URL: z.url(),
  VITE_SUPABASE_URL: z.url(),
  VITE_SUPABASE_PUBLISHABLE_KEY: z.string().min(20),
});

const parsed = runtimeConfigSchema.safeParse(import.meta.env);

if (!parsed.success) {
  const fields = parsed.error.issues
    .map((issue) => issue.path.join("."))
    .join(", ");
  throw new Error(`Configuração pública inválida ou ausente: ${fields}`);
}

export const runtimeConfig = {
  apiBaseUrl: parsed.data.VITE_API_BASE_URL.replace(/\/$/, ""),
  supabaseUrl: parsed.data.VITE_SUPABASE_URL,
  supabasePublishableKey: parsed.data.VITE_SUPABASE_PUBLISHABLE_KEY,
} as const;
